import React from 'react';

import QuestionTrackerModal from './QuestionTrackerModal/QuestionTrackerModal.react';
import UpgradeCallToActionModal from './UpgradeCallToActionModal/UpgradeCallToActionModal.react';

interface Props {
  pathname: string;
}

export default function ModalCollection({pathname}: Props) {
  return (
    <>
      <UpgradeCallToActionModal pathname={pathname} />
      <QuestionTrackerModal />
    </>
  );
}
